import { routes } from "@bezoned/shared/routes.js";
import { DoorArrowRightRegular } from "@fluentui/react-icons";
import { stageView } from "@microsoft/teams-js";
import type { MouseEvent } from "react";
import { useState } from "react";

import { useOfficeExit } from "../../../features/office/use-office-exit.js";
import { updateSearchParams } from "../../../utils/url-search-params.js";
import { GeneralOfficeAction } from "./general-office-action.js";

export const LeaveOfficeAction = () => {
  const [loading, setLoading] = useState(false);
  const { leaveOffice } = useOfficeExit();

  const redirectToChooseTeamPage = async (
    event: MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    setLoading(true);

    // Navigation must not depend on a Fluid connection succeeding. Once the
    // request reaches the API, durable server cleanup handles retries.
    try {
      await leaveOffice();
    } catch {
      // Navigation is intentionally independent of best-effort cleanup.
    }

    const isStageView =
      new URLSearchParams(window.location.search).get("stage") === "true";

    if (isStageView) {
      try {
        if (stageView.self.isSupported()) {
          await stageView.self.close();
          return;
        }
      } catch {
        // Fall back to normal navigation when the Teams SDK cannot close the view.
      }
    }

    const currentSearchParams = updateSearchParams(window.location.search, {
      remove: ["teamId"],
    });

    window.location.assign(
      `${routes.protected.chooseTeam}${currentSearchParams}`
    );
  };

  return (
    <GeneralOfficeAction
      icon={<DoorArrowRightRegular />}
      label="Leave Office"
      loading={loading}
      onClick={redirectToChooseTeamPage}
      variant="primary"
    />
  );
};
